import { BpmnModel, BpmnModelHelper, ExtensionElement, ExtensionMethod } from "@edp-pmf/bpmn-model";

export class ProcessHeader extends ExtensionElement {
    static CLR_TYPE_ID = "bpm.ProcessHeader";
    ClrTypeID: string = ProcessHeader.CLR_TYPE_ID;

    beId: string;
    beName: string;
    voId: string;
    voName: string;
    eventRouterConditionsContent: string;

    protected ResetBeforeLoadFrom() {
        super.ResetBeforeLoadFrom();

        this.beId = null;
        this.beName = null;
        this.voId = null;
        this.voName = null;
        this.eventRouterConditionsContent = null;
    }

    public ConvertToJsonObject(): {} {
        let obj = super.ConvertToJsonObject();
        ExtensionMethod.SetAttributeValue(obj, "beId", this.beId);
        ExtensionMethod.SetAttributeValue(obj, "beName", this.beName);
        ExtensionMethod.SetAttributeValue(obj, "voId", this.voId);
        ExtensionMethod.SetAttributeValue(obj, "voName", this.voName);
        ExtensionMethod.SetAttributeValue(obj, "eventRouterConditionsContent", this.eventRouterConditionsContent);
        return obj;
    }

    public LoadFromJsonObject(obj: {}): void {
        super.LoadFromJsonObject(obj);

        this.beId = ExtensionMethod.GetAttributeValue4String(obj, "beId");
        this.beName = ExtensionMethod.GetAttributeValue4String(obj, "beName");
        this.voId = ExtensionMethod.GetAttributeValue4String(obj, "voId");
        this.voName = ExtensionMethod.GetAttributeValue4String(obj, "voName");
        this.eventRouterConditionsContent = ExtensionMethod.GetAttributeValue4String(obj, "eventRouterConditionsContent");
    }

    NewInstance(): ProcessHeader {
        return new ProcessHeader(this.Model);
    }

    clone(): ProcessHeader {
        const c = this.NewInstance();

        c.beId = this.beId;
        c.beName = this.beName;
        c.voId = this.voId;
        c.voName = this.voName;
        c.eventRouterConditionsContent = this.eventRouterConditionsContent;

        return c;
    }
}

BpmnModelHelper.RegisterElementType(new ProcessHeader(new BpmnModel()));
